<template>
  <md-tab id="tab-market-area" md-label="Market Area" md-icon="map">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2">
        <div>
          <PulseLoader :loading="!loaded" :class="{ hide: loaded }"></PulseLoader>
        </div>
        <div :key="componentKey" v-if="loaded && searchMarketAreas == null && !searchLoadingMarketArea">
          <div @click="chooseDefaultMarket($event)" :class="checkUS()?'US [9999] available unclicked':'US [9999] unavailable unclicked'">
            ALL US
          </div>
          <div v-for="(stateId, state) in markets" :key="state" @click="chooseMarket($event)" :class="
            `${removeSpaces(state)} [${stateId}] ${availableMarkets.includes(state) && checkStates() ? 'available' : 'unavailable'
            } unclicked correct-padding `
          ">
            {{ state }}
          </div>
        </div>
        <!-- <div>
          <pulse-loader
            :color="'blue'"
            :loading="searchLoadingMarketArea && searchMarketAreas == null"
          ></pulse-loader>
        </div> -->
        <div v-if="searchMarketAreas != null">
          <div v-if="
            searchMarketAreas[0].states.length == 0 &&
            searchMarketAreas[0].metros.length == 0 &&
            searchMarketAreas[0].counties.length == 0 &&
            searchMarketAreas[0].zips.length == 0
          " class="available">
            No results! Please try different keyword.
          </div>
          <div v-if="searchMarketAreas[0].states.length != 0" class="available">
            States:
            <div v-for="(searchMarket, searchIndex) in searchMarketAreas[0].states" :key="searchIndex + 'collapse'"
              :class="
                `${searchMarket.state} [${searchMarket.state_id}] ${searchMarketAreas[1].states.some(
                  (key) => key.state === searchMarket.state
                ) && checkStates()
                  ? 'available'
                  : 'unavailable'
                } `
              " @click="chooseMarket($event)">
              {{ searchMarket.state }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].metros.length != 0" class="available">
            Metro Areas:
            <div v-for="(searchMarket, searchIndex) in searchMarketAreas[0].metros" :key="searchIndex + 'collapse'"
              :class="
                `${searchMarket.CBSA_Title} [${searchMarket.metro_id}] ${searchMarketAreas[1].metros.some(
                  (key) => key.CBSA_Title === searchMarket.CBSA_Title
                ) && checkMetros()
                  ? 'available'
                  : 'unavailable'
                } `
              " @click="chooseMetroArea(searchMarket,$event)">
              {{ searchMarket.CBSA_Title }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].counties.length != 0" class="available">
            Counties:
            <div v-for="(searchMarket, searchIndex) in searchMarketAreas[0]
            .counties" :key="searchIndex + 'collapse'" :class="
              `${searchMarket.county} [${searchMarket.county_id}] ${searchMarketAreas[1].counties.some(
                (key) => key.county === searchMarket.county
              ) && checkCounties()
                ? 'available'
                : 'unavailable'
              } `
            " @click="chooseCounty(searchMarket,$event)">
              {{ searchMarket.county }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].zips.length != 0" class="available">
            Zips:
            <div v-for="(searchMarket, searchIndex) in searchMarketAreas[0].zips" :key="searchIndex + 'collapse'"
              :class="
  `${searchMarket.zip} [${searchMarket.zip}] ${searchMarketAreas[1].zips.some(
                  (key) => key.zip === searchMarket.zip
                ) && checkZIPS()
                  ? 'available'
                  : 'unavailable'
                } `
              ">
              <input @change="chooseSearchResultZips(checkedBoxes)" type="checkbox" :id="'checkbox' + searchIndex"
                :value="searchMarket.zip" v-model="checkedBoxes" />

              {{ searchMarket.zip }}
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 search_panel">
        <sidebar-map />
        <sidebar-search @load-area="loadArea" tab="market_area" title="Favorite Market Areas" />
      </div>
    </div>
  </md-tab>
</template>

<script>
import SidebarMap from './SidebarMap';
import SidebarSearch from './SidebarSearch';
import axios from 'axios';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { PulseLoader } from '@/components';
import Vue from 'vue';
import MarketAreaTabTable from './MarketAreaTabTable';

export default {
  name: 'market-area-tab',
  props: {},
  components: {
    SidebarMap,
    SidebarSearch,
    PulseLoader,
  },
  data() {
    return {
      search: 'autofill text area names...',
      markets: {},
      availableMarkets: [],
      checkedBoxes: [],
      loaded: false,
      componentKey: 0,
      route: null,
    };
  },
  methods: {
    nextTickInput: function () {

           this.$nextTick(() => {
        this.chooseSearchResultZips(this.checkedBoxes);
      });
    },
    checkCounties: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.geo_counties)
          return true;
        else
          return false;
      else
        return true;
    },
    checkMetros: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.geo_metros)
          return true;
        else
          return false;
      else
        return true;
    },
    checkUS: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.geo_national)
          return true;
        else
          return false;
      else
        return true;
    },
    checkZIPS: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.geo_zips)
          return true;
        else
          return false;
      else
        return true;
    },
    checkStates: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.geo_states)
          return true;
        else
          return false;
      else
        return true;
    },
    loadArea: function (e) {
      this.loaded = !e.isLoading;
    },
    removeSpaces: function (name) {
      return name.replace(/\s/g, '').replace(/,/g, ' ');
    },
    getData: function (name) {
      if (name && name!='open') {

        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function (name) {
      if (name) {

        return name.split('[')[0];
      }
    },
    chooseSearchResultZips: function (zips) {

      this.$store.commit('M_SET_MARKET_AREA', `${zips} [zips]`);
      this.chooseZips(zips);
    },
    chooseSearchResult: function (event) {

      const id = event.target.className.split(' ')[0].split('-')[1];
      const title = this.getName(event.target.innerText);

      this.$store.commit('M_SET_MARKET_AREA', `${title} [${id}]`);
    },
    getMarkets: async function () {
      //availableMarkets
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'imr',
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { states } = res.data.data;
          // The industry-scoped response is served from the pre-dumped USMR
          // table and only contains states WITH data — it is both the list and
          // the availability set (no-data states are hidden, not dimmed), so
          // the old unfiltered industry='0' probe (a full-table aggregate that
          // could take 30-45s) is gone entirely.
          states.forEach((market) => {
            this.availableMarkets.push(market.state);
            this.markets[market.state] = market.state_id;
          });
          this.loaded = true;
        });
    },
    // Add request to /user/search_profiles/imr (POST)
    chooseMetroArea: async function (item, event) {

      event.stopPropagation();
      this.$store.commit(
        'M_SET_MARKET_AREA',
        `${item.CBSA_Title} [${item.metro_id}]`
      );

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              zips: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('M_SET_PROFILE_ID', id);
        });

     const items = document.querySelectorAll('[name="marketAreaBox"]');
      for (item of items) {
        item.checked = false;
      }
    },
    // Add request to /user/search_profiles/imr (POST)
    chooseCounty: async function (item, event) {

      event.stopPropagation();
      this.$store.commit(
        'M_SET_MARKET_AREA',
        `${item.county} [${item.county_id}]`
      );

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              zips: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('M_SET_PROFILE_ID', id);
        });

      const items = document.querySelectorAll('[name="marketAreaBox"]');
      for (item of items) {
        item.checked = false;
      }
    },
    chooseZips: async function (zips) {

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              zips: zips,
              area: this.getData(this.mMarketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('M_SET_PROFILE_ID', id);
          this.$store.commit('M_SET_MARKET_AREA', `${zips} [zips]`);
        });
    },
    chooseMarket: async function (event) {

      this.$store.commit('M_SET_MARKET_AREA', null);
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let query = event.target.className;

      if (!query) {
        return;
      }
      let title = query.split(' ')[0];
      let id = this.getData(query);
      let currentDiv = document.getElementsByClassName(`${title} [${id}]`)[0];

      let availableAreas = [];
      let areas = {};

      this.$store.commit('M_SET_MARKET_AREA', `${title} [${id}]`);

      // Show loading bar
      let loadingDiv = document.createElement('div');
      let loadingMount = document.createElement('div');
      loadingDiv.setAttribute('class', 'available');
      loadingDiv.appendChild(loadingMount);
      currentDiv.appendChild(loadingDiv);

      if (title !== 'US') {
        const pulseLoader = Vue.extend(PulseLoader);
        const pulseLoaderToMount = new pulseLoader({
          propsData: {
            color: 'blue',
            loading: true,
          },
        }).$mount(loadingMount);
      }

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              zips: '0',
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('M_SET_PROFILE_ID', id);
        });

      //available markets
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'imr',
            state_id: id,
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          availableAreas = res.data.data;
        });

      // Pre-dumped fast path: the industry-scoped response above only contains
      // metros with data, so it is both the list and the availability set —
      // the second (unscoped) per-state call is gone.
      areas = availableAreas;

      while (currentDiv.firstChild != currentDiv.lastChild) {
        currentDiv.removeChild(currentDiv.lastChild);
      }

      if (title !== 'US' && currentDiv.classList.contains('unclicked')) {
        currentDiv.classList.remove('unclicked');
        currentDiv.classList.add('clicked');

        let flexDiv = document.createElement('div');
        flexDiv.className = 'sub_areas';
        flexDiv.setAttribute('style', 'display: flex;');
        currentDiv.appendChild(flexDiv);

        //Metro Areas Scrollable Table
        let tableDiv0 = document.createElement('span');
        let tableMount0 = document.createElement('span');
        tableDiv0.appendChild(tableMount0);
        flexDiv.appendChild(tableDiv0);
        const MarketAreaTable = Vue.extend(MarketAreaTabTable);
        const MarketAreaTableToMount = new MarketAreaTable({
          propsData: {
            data: areas.metros,
            availableData: availableAreas.metros,
            attribute: 'CBSA_Title',
            name: 'Metro Areas',
            onSelect: this.chooseMetroArea,
          },
        }).$mount(tableMount0);

        //Counties Scrollable Table
        let tableDiv1 = document.createElement('span');
        let tableMount1 = document.createElement('span');
        tableDiv1.appendChild(tableMount1);
        flexDiv.appendChild(tableDiv1);
        const MarketAreaTableToMount1 = new MarketAreaTable({
          propsData: {
            data: areas.counties,
            availableData: availableAreas.counties,
            attribute: 'county',
            name: 'Counties',
            onSelect: this.chooseCounty,
          },
        }).$mount(tableMount1);

        //Zips Scrollable Table
        let tableDiv2 = document.createElement('span');
        let tableMount2 = document.createElement('span');
        tableDiv2.appendChild(tableMount2);
        flexDiv.appendChild(tableDiv2);
        const MarketAreaTableToMount2 = new MarketAreaTable({
          propsData: {
            data: areas.zips,
            availableData: availableAreas.zips,
            attribute: 'zip',
            name: 'Zip codes',
            onSelect: this.chooseZips,
          },
        }).$mount(tableMount2);
      } else {
        while (currentDiv.firstChild != currentDiv.lastChild) {
          currentDiv.removeChild(currentDiv.lastChild);
        }
        currentDiv.classList.remove('clicked');
        currentDiv.classList.add('unclicked');
      }
    },
    chooseDefaultMarket: async function () {

      this.$store.commit('M_SET_MARKET_AREA', null);
      this.$store.commit('M_SET_MARKET_AREA', `US [9999]`);
      this.saveProfile();
    },
    saveProfile: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });
    },
  },
  async created() {

    if (this.$route.name === 'NewMarketProfile')
      this.route = '/user/search_profiles/imr';
    else
      this.route = '/user/search_reports/imr';

    await this.getMarkets();
  },
  computed: {
    profileId() {
      return this.$store.getters.mProfileId;
    },
    mIndustry() {
      return this.$store.getters.mIndustry;
    },
    mMarketArea() {
      return this.$store.getters.mMarketArea;
    },
    searchMarketAreas() {
      return this.$store.getters.mSearchMarketAreas;
    },
    searchLoadingMarketArea() {
      return this.$store.getters.mSearchLoadingMarketArea;
    },
  },
  watch: {
    // industry(newValue, oldValue) {
    //   this.getMarkets();
    //   this.componentKey = newValue;
    // },
  },
};
</script>
<style lang="scss">
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  margin: 16px;
}

.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
}

.correct-padding {
  padding-left: 16px;
}

.available:hover {
  color: #1a7bfa;
}
</style>
